import React, { useMemo } from "react";
import settings from "@settings";
import { sidebarelement, sidebarHeader } from "../styles";
import { NewsProps } from "../types";
import { FlexBox, Label } from "@ui";
import { getDateString, useGetEntry } from "@provider";

const News: React.FC<NewsProps> = ({ category, displayAllNews = false }) => {
  const { entrys: news } = useGetEntry();

  const newsArray = useMemo(() => {
    const sixtyDaysAgo = new Date();
    sixtyDaysAgo.setDate(sixtyDaysAgo.getDate() - 60);
    const now = new Date();
    const actualNews = news.filter((value) => {
      if (!value?.date) return false;
      const newsDate = new Date(value.date);
      return newsDate <= now && newsDate >= sixtyDaysAgo;
    });
    if (displayAllNews) {
      return actualNews.slice(0, 5);
    }
    if (category) {
      return actualNews
        .filter((value) => value?.categories?.includes(category))
        .slice(0, 5);
    }
    return [];
  }, [news, category, displayAllNews]);

  return (
    <div
      css={[
        {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        },
      ]}
    >
      <div css={sidebarHeader}>Aktuelles</div>
      {newsArray.length > 0 ? (
        <FlexBox
          direction="column"
          align="stretch"
          gap={settings.sizes.medium}
          hasFullWidth
        >
          {newsArray.sort((a, b) => new Date(b.date!).getTime() - new Date(a.date!).getTime()).map((value) => (
            <div key={value.objectId} css={sidebarelement}>
              <FlexBox direction="column" gap={settings.sizes.small}>
                <Label text={getDateString(value.date!).date} />
                <h4>{value.title}</h4>
                {value.text && (
                  <div dangerouslySetInnerHTML={{ __html: value.text }} />
                )}
              </FlexBox>
            </div>
          ))}
        </FlexBox>
      ) : (
        <div>
          <p>Hier gibt es gerade keine Neuigkeiten</p>
        </div>
      )}
    </div>
  );
};

export default News;
